import { AxiosError } from "axios";
import { ApiErrorResponse } from "types/models.ts";

export function extractValidationErrorMessages(error: AxiosError<ApiErrorResponse>): string[] {
    const fieldErrors = error.response?.data?.exception?.errors;

    if (fieldErrors && Object.keys(fieldErrors).length > 0) {
        return Object.values(fieldErrors).flat();
    }

    const message = error.response?.data?.message;

    return message ? [message] : [];
}
